import { Button, ButtonProps } from '@mui/material';
import React from 'react';

type ButtonIconsProps = {
  isAccentColor?: boolean;
} & ButtonProps;

const ButtonIcons: React.FC<ButtonIconsProps> = ({ isAccentColor, ...props }) => {
  const dynamicSx = {
    color: isAccentColor ? 'var(--accent-color)' : 'var(--secondary-color)',
    borderColor: isAccentColor ? 'var(--accent-color)' : 'var(--secondary-color)',
    padding: 0,
    minWidth: '32px',
    minHeight: '32px',
    borderRadius: '6px',
    ...props.sx,
  };

  return (
    <Button variant="outlined" sx={dynamicSx} {...props}>
      {props.children}
    </Button>
  );
};

export { ButtonIcons };
